













import CurrencyFormatter from '../../currencyFormatter';

export default {
    props: {
        ageName: String,
        price: Number,
        ageFrom: Number,
        ageTo: Number,
        ticketId: Number,
        ageId: Number,
        elementIndex: Number,
        currency: String,
        seasonId: Number,
        disableMax: Boolean
    },
    data() {
        return {
            count: 0
        }
    },
    computed: {
        totalPrice() {
            return this.price * this.count;
        },
        renderedPrice() {
            return CurrencyFormatter(this.currency).format(this.price);
        },
        renderText() {
            const text = `${this.ageTo >= 100 ? '+' : ''}${this.ageFrom}${this.ageTo >= 100 ? '' : '-' + this.ageTo} år ${this.price === 0 ? "(" + this.ageName + ")" : ""}`;
            return text;
        }
    },
    methods: {
        reset: function () {
            this.$refs.spinner.getVueInstance().reset(); //Tager reference finder instance og kalder reset method p� den komponenet.
        },
        changed(value) {
            this.count = value.detail[0];
            this.emitTotalPrice();
        },
        emitTotalPrice() {

            //const parent = (<any>this.$el).closest("experience-dropdown").getVueInstance();
            this.$emit("totalPrice", this.totalPrice);
        }
    }
}
